import React, { useEffect, useState } from 'react';
import CustomDropdown from '../../../Component/CustomDropdown/CustomDropdown';
import Toggle from '../../../Component/Toggle/Toggle';
import { useDispatch, useSelector } from 'react-redux';
import { fiveXFiveDefaultPeriod, fiveXFiveOvertimePeriod, possessionArrow, threeXThreeDefaultPeriod, threeXThreeOvertimePeriod, toggleFoul, toggleGoalAnytimeDuringOvertime, toggleGoalWithinLast2Minutes, toggleOutOfBounds, toggleShotClockCheck, toggleShotClockOption, toggleShotClockViolation, toggleTimeout, topTimerWhenFoulCalled, whenToResetFoul } from '../../../redux/reducers/settingReducer';
import Loader from '../../../Component/Loader/Loader';


const General = () => {
  const dispatch = useDispatch();
  const settingReducer = useSelector((state) => state?.settingReducer);
  const playersReducer = useSelector((state) => state?.playersReducer);
  const generalSettings = settingReducer?.General
  const eventType = playersReducer?.eventType
  const whenToResetFoulData = generalSettings?.whenToResetFoul
  const possessionArrowData = generalSettings?.possessionArrow
  const defaultTimerPerPeriod = generalSettings?.fiveXFive?.defaultTimerPerPeriod
  const defaultTimerPerOvertime = generalSettings?.fiveXFive?.defaultTimerPerOvertime
  const defaultTimerPerPeriodThree = generalSettings?.threeXThree?.defaultTimerPerPeriod
  const defaultTimerPerOvertimeThree = generalSettings?.threeXThree?.defaultTimerPerOvertime
  const topTimerWhenFoulCalledData = generalSettings?.topTimerWhenFoulCalled

  const event_id = localStorage.getItem("event_id");

  const [isLoad, setIsLoad] = useState(false);
  const token = localStorage.getItem("token");

  const resetFoulOptions = [
    { value: 'Quarter', label: 'Quarter' },
    { value: 'Half', label: 'Half' },
  ];

  const possessionArrowOptions = [
    { value: 'shotclock', label: 'Shot Clock' },
    { value: 'goalclock', label: 'Goal Clock' },
  ];


  const handleResetFoul = async (value) => {

    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", defaultTimerPerPeriod);
      formData.append("time_overtime", defaultTimerPerOvertime);
      formData.append("foul_reset", value);
      formData.append("possession_arrow", possessionArrowData);
      formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
      formData.append("rst_shot_clock_violation", generalSettings?.shotClockOptions?.shotClockViolation);
      formData.append("rst_foul", generalSettings?.shotClockOptions?.foul);
      formData.append('rst_timeout', generalSettings?.shotClockOptions?.timeout);
      formData.append('rst_outofbounds', generalSettings?.shotClockOptions?.outOfBounds);
      formData.append('rst_goallast2min', generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
      formData.append('rst_goal_anytime_overtime', generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
      formData.append('stop_timer_foul', topTimerWhenFoulCalledData);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        fetchSettings();
        dispatch(whenToResetFoul(value));
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }
    } catch (error) {
    }

  };

  const handleToggleChange = async (toggleName) => {

    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", defaultTimerPerPeriod);
      formData.append("time_overtime", defaultTimerPerOvertime);
      formData.append("foul_reset", whenToResetFoulData);
      formData.append("possession_arrow", possessionArrowData);
      formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
      formData.append("rst_shot_clock_violation", generalSettings?.shotClockOptions?.shotClockViolation);
      formData.append("rst_foul", generalSettings?.shotClockOptions?.foul);
      formData.append('rst_timeout', generalSettings?.shotClockOptions?.timeout);
      formData.append('rst_outofbounds', generalSettings?.shotClockOptions?.outOfBounds);
      formData.append('rst_goallast2min', generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
      formData.append('rst_goal_anytime_overtime', generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
      formData.append('stop_timer_foul', !topTimerWhenFoulCalledData);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        dispatch(topTimerWhenFoulCalled(!topTimerWhenFoulCalledData));
        fetchSettings();
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }
    } catch (error) {
    }
  };

  const handleFiveXFiveOvertimePeriod = async (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/; // Allows only numeric characters
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, ''); // Remove any non-numeric characters
    }
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", defaultTimerPerPeriod);
      formData.append("time_overtime", inputValue);
      formData.append("foul_reset", whenToResetFoulData);
      formData.append("possession_arrow", possessionArrowData);
      formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
      formData.append("rst_shot_clock_violation", generalSettings?.shotClockOptions?.shotClockViolation);
      formData.append("rst_foul", generalSettings?.shotClockOptions?.foul);
      formData.append('rst_timeout', generalSettings?.shotClockOptions?.timeout);
      formData.append('rst_outofbounds', generalSettings?.shotClockOptions?.outOfBounds);
      formData.append('rst_goallast2min', generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
      formData.append('rst_goal_anytime_overtime', generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
      formData.append('stop_timer_foul', topTimerWhenFoulCalledData);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        fetchSettings();
        dispatch(fiveXFiveOvertimePeriod(inputValue));
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }
    } catch (error) {
    }
  };
  const handleFiveXFiveDefaultPeriod = async (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/; // Allows only numeric characters
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, ''); // Remove any non-numeric characters
    }


    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", inputValue);
      formData.append("time_overtime", defaultTimerPerOvertime);
      formData.append("foul_reset", whenToResetFoulData);
      formData.append("possession_arrow", possessionArrowData);
      formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
      formData.append("rst_shot_clock_violation", generalSettings?.shotClockOptions?.shotClockViolation);
      formData.append("rst_foul", generalSettings?.shotClockOptions?.foul);
      formData.append('rst_timeout', generalSettings?.shotClockOptions?.timeout);
      formData.append('rst_outofbounds', generalSettings?.shotClockOptions?.outOfBounds);
      formData.append('rst_goallast2min', generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
      formData.append('rst_goal_anytime_overtime', generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
      formData.append('stop_timer_foul', topTimerWhenFoulCalledData);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        fetchSettings();
        dispatch(fiveXFiveDefaultPeriod(inputValue));
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }
    } catch (error) {
    }


  };
  const handleThreeXThreeDefaultPeriod = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/; // Allows only numeric characters
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, ''); // Remove any non-numeric characters
    }

    dispatch(threeXThreeDefaultPeriod(inputValue));
  };
  const handleThreeXThreeOvertimePeriod = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/; // Allows only numeric characters
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/\D/g, ''); // Remove any non-numeric characters
    }
    dispatch(threeXThreeOvertimePeriod(inputValue));
  };

  const shotClockOptions = [
    {
      sectionLabel: "",
      key: "shotClock",
      sectionValue: [
        {
          label: "Shot Clock",
          key: "shotClockCheck",
          value: generalSettings?.shotClockOptions?.shotClockCheck
        }
      ]
    },
    ...(generalSettings?.shotClockOptions?.shotClockCheck ? [{
      sectionLabel: "Stop Main Clock at:",
      key: "stopMainClockAt",
      sectionValue: [
        {
          label: "Shot Clock Violation",
          key: "shotClockViolation",
          value: generalSettings?.shotClockOptions?.shotClockViolation
        },
        {
          label: "Foul",
          key: "foul",
          value: generalSettings?.shotClockOptions?.foul
        },
        {
          label: "Timeout",
          key: "timeout",
          value: generalSettings?.shotClockOptions?.timeout
        },
        {
          label: "Out of bounds",
          key: "outOfBounds",
          value: generalSettings?.shotClockOptions?.outOfBounds
        },
        {
          label: "A goal within last 2 minutes of each period",
          key: "goalWithinLast2Minutes",
          value: generalSettings?.shotClockOptions?.goalWithinLast2Minutes
        },
        {
          label: "A goal anytime during overtime",
          key: "goalAnytimeDuringOvertime",
          value: generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime
        }
      ]
    }] : [])
  ]
  const toggleShotClock = (value) => {
    setLoading(true);

    dispatch(toggleShotClockOption(value));
    sendShotClockDataApi(value)
  }
  const handlePossessionArrow = async (value) => {

    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", defaultTimerPerPeriod);
      formData.append("time_overtime", defaultTimerPerOvertime);
      formData.append("foul_reset", whenToResetFoulData);
      formData.append("possession_arrow", value);
      formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
      formData.append("rst_shot_clock_violation", generalSettings?.shotClockOptions?.shotClockViolation);
      formData.append("rst_foul", generalSettings?.shotClockOptions?.foul);
      formData.append('rst_timeout', generalSettings?.shotClockOptions?.timeout);
      formData.append('rst_outofbounds', generalSettings?.shotClockOptions?.outOfBounds);
      formData.append('rst_goallast2min', generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
      formData.append('rst_goal_anytime_overtime', generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
      formData.append('stop_timer_foul', topTimerWhenFoulCalledData);

      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        fetchSettings();
        dispatch(possessionArrow(value));
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }
    } catch (error) {
    }


  }

  const [setting, setSetting] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/get_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      setSetting(responseData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    if (event_id && !isLoad) {
      fetchSettings();
      setIsLoad(true)


    }
  }, [event_id]);


  useEffect(() => {
    if (setting) {
      // dispatch(fiveXFiveDefaultPeriod(setting?.time_period))
      // dispatch(fiveXFiveOvertimePeriod(setting?.time_overtime));
      dispatch(topTimerWhenFoulCalled(setting?.stop_timer_foul));
      dispatch(whenToResetFoul(setting?.foul_reset));
      dispatch(possessionArrow(setting?.possession_arrow));
      dispatch(toggleShotClockCheck(setting?.shot_clock));
      dispatch(toggleShotClockViolation(setting?.rst_shot_clock_violation));
      dispatch(toggleFoul(setting?.rst_foul));
      dispatch(toggleTimeout(setting?.rst_timeout));
      dispatch(toggleOutOfBounds(setting?.rst_outofbounds));
      dispatch(toggleGoalWithinLast2Minutes(setting?.rst_goallast2min));
      dispatch(toggleGoalAnytimeDuringOvertime(setting?.rst_goal_anytime_overtime));

    }
  }, [setting])

  const sendShotClockDataApi = async (value) => {
    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/set_Setting/`;
      const formData = new FormData();
      formData.append("e_id", event_id);
      formData.append("time_period", defaultTimerPerPeriod);
      formData.append("time_overtime", defaultTimerPerOvertime);
      formData.append("foul_reset", whenToResetFoulData);
      formData.append("possession_arrow", possessionArrowData);
      // edit shot clock options
      if (value == 'shotClockCheck') {

        formData.append("shot_clock", value == 'shotClockCheck' && !generalSettings?.shotClockOptions?.shotClockCheck);
        formData.append("rst_shot_clock_violation", !generalSettings?.shotClockOptions?.shotClockViolation);
        formData.append("rst_foul", !generalSettings?.shotClockOptions?.foul);
        formData.append('rst_timeout', !generalSettings?.shotClockOptions?.timeout);
        formData.append('rst_outofbounds', !generalSettings?.shotClockOptions?.outOfBounds);
        formData.append('rst_goallast2min', !generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
        formData.append('rst_goal_anytime_overtime', !generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
        formData.append('stop_timer_foul', topTimerWhenFoulCalledData);
      } else {

        formData.append("shot_clock", generalSettings?.shotClockOptions?.shotClockCheck);
        formData.append("rst_shot_clock_violation", value == 'shotClockViolation' ? !generalSettings?.shotClockOptions?.shotClockViolation : generalSettings?.shotClockOptions?.shotClockViolation);
        formData.append("rst_foul", value == 'foul' ? !generalSettings?.shotClockOptions?.foul : generalSettings?.shotClockOptions?.foul);
        formData.append('rst_timeout', value == 'timeout' ? !generalSettings?.shotClockOptions?.timeout : generalSettings?.shotClockOptions?.timeout);
        formData.append('rst_outofbounds', value == 'outOfBounds' ? !generalSettings?.shotClockOptions?.outOfBounds : generalSettings?.shotClockOptions?.outOfBounds);
        formData.append('rst_goallast2min', value == 'goalWithinLast2Minutes' ? !generalSettings?.shotClockOptions?.goalWithinLast2Minutes : generalSettings?.shotClockOptions?.goalWithinLast2Minutes);
        formData.append('rst_goal_anytime_overtime', value == 'goalAnytimeDuringOvertime' ? !generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime : generalSettings?.shotClockOptions?.goalAnytimeDuringOvertime);
        formData.append('stop_timer_foul', topTimerWhenFoulCalledData);
      }

      //  // edit shot clock options
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      if (responseData) {
        fetchSettings();
        // setLoading(false);
        toast.success("Shot clock data updated successfully");
      } else {
        toast.error("Error updating shot clock data");
      }

    } catch (error) {
      console.error("Error sending shot clock data:", error);
    }
  }


  return (

    <div className='w-full h-full'>
      <div className='w-full h-full relative'>
        {
          !event_id && <div className='absolute top-0 left-0 w-full h-full bg-black/35 backdrop-blur-sm  z-10 max-w-[672px] flex justify-center items-center'>

          <p className='text-5xl text-black font-bebas  font-medium'>Please Select Any Event</p>
        </div>
        }
        {
          loading ?

            <div className='w-full h-full flex justify-center items-center'>
              <Loader />
            </div>
            : <div className='max-w-[672px] w-full flex flex-col gap-6 px-2 md:px-0'>


              <div className='w-full max-w-[672px] flex justify-between items-center '>
                <p className='text-base text-black font-montserrat font-medium'>Event Type</p>
                <p className='bg-[#E8E8E8] min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10  px-2 py-3 rounded   w-full flex justify-center items-center gap-5 '>{eventType === "5x5" ? "5x5" : "3x3"}</p>
              </div>
              {/* for 5*5 */}
              {
                eventType === "5x5" && <div className='w-full border flex flex-col gap-6 rounded-md p-6 border-[#CCCCCC]'>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-sm md:text-base text-black font-montserrat font-medium'>Total main players are </p>
                    <p className='text-xl md:text-base text-[#1A1A1A] font-montserrat font-medium'>5 </p>
                  </div>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-sm md:text-base w-full text-black font-montserrat font-medium'>Period System</p>
                    <div className=' flex flex-col md:flex-row gap-2 w-full justify-end'>


                      <div className='font-montserrat font-medium text-base text-right text-nowrap block'>
                        4 Quarter
                      </div>
                    </div>
                  </div>
                  <div className='w-full max-w-[672px] flex justify-between flex-col md:flex-row items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Please enter default timer (in minutes) per period</p>

                    <input
                      className='bg-[#E8E8E8] appearance-none outline-none min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10 px-2 py-3 rounded w-full flex justify-center items-center gap-5'
                      type="number"
                      defaultValue={defaultTimerPerPeriod}
                      onBlur={handleFiveXFiveDefaultPeriod}
                    />



                  </div>
                  <div className='w-full max-w-[672px] flex justify-between flex-col md:flex-row items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Please enter default timer (in minutes) per Overtime</p>


                    <input
                      className='bg-[#E8E8E8] appearance-none outline-none min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10 px-2 py-3 rounded w-full flex justify-center items-center gap-5'
                      type="number"
                      defaultValue={defaultTimerPerOvertime}
                      onBlur={handleFiveXFiveOvertimePeriod}
                    />

                  </div>
                </div>
              }

              {
                eventType === "3x3" && <div className='w-full border flex flex-col gap-6 rounded-md p-6 border-[#CCCCCC]'>

                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-sm md:text-base text-black font-montserrat font-medium'>Total main players are </p>
                    <p className='text-xl md:text-base text-[#1A1A1A] font-montserrat font-medium'>3 </p>
                  </div>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Disabled option </p>
                    <div className='flex items-center gap-3'>
                      <p className='text-base text-[#1A1A1A]  font-medium font-bebas'>3PT Made</p>
                      <p className='text-base text-[#1A1A1A]  font-medium font-bebas'>3PT Miss</p>
                    </div>
                  </div>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Period system </p>
                    <p className='text-base text-[#1A1A1A]  font-medium font-bebas'>Single</p>
                  </div>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Please enter default timer (in minutes) per period</p>

                    <input
                      className='bg-[#E8E8E8] appearance-none outline-none min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10 px-2 py-3 rounded w-full flex justify-center items-center gap-5'
                      type="number"
                      defaultValue={defaultTimerPerPeriodThree}
                      onInput={handleThreeXThreeDefaultPeriod}
                    />
                  </div>
                  <div className='w-full max-w-[672px] flex flex-col md:flex-row justify-between items-start md:items-center gap-2'>
                    <p className='text-base text-black font-montserrat font-medium'>Please enter default timer (in minutes) per Overtime</p>

                    <input
                      className='bg-[#E8E8E8] appearance-none outline-none min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10 px-2 py-3 rounded w-full flex justify-center items-center gap-5'
                      type="number"
                      defaultValue={defaultTimerPerOvertimeThree}
                      onInput={handleThreeXThreeOvertimePeriod}
                    />
                  </div>
                </div>
              }
              {/* for 3*3 */}
              <div className='w-full max-w-[672px] flex justify-between items-center'>
                <p className='text-base text-black font-montserrat font-medium'>Stop timer when foul called</p>
                <Toggle
                  checked={topTimerWhenFoulCalledData}
                  onChange={() => handleToggleChange("topTimerWhenFoulCalledData")}
                />
              </div>

              {
                eventType == '5x5' &&
                <div className='w-full max-w-[672px] flex justify-between items-center'>
                  <p className='text-base text-black font-montserrat font-medium'>When to reset foul</p>
                  <CustomDropdown
                    customStyle={`bg-[#E8E8E8] min-w-[120px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10  px-2 py-3 rounded cursor-pointer  w-full flex justify-center items-center gap-5 `}
                    customStyleDropdownList={`font-montserrat font-medium max-w-[120px] absolute bg-white rounded-md shadow-md w-full mt-3 p-4 flex flex-col justify-center items-center `}
                    liCustomStyle={`cursor-pointer py-2 border-b hover:font-semibold w-full`}
                    options={resetFoulOptions} onChange={handleResetFoul} defaultValue={whenToResetFoulData} />
                </div>
              }
              <div className='w-full max-w-[672px] flex justify-between items-center'>
                <p className='text-base text-black font-montserrat font-medium'>Method to determine possession arrow</p>
                <CustomDropdown
                  customStyle={`bg-[#E8E8E8] min-w-[160px] border-none font-bebas text-base text-[#4A4A4A] max-w-[120px] h-10  px-2 py-3 rounded cursor-pointer  w-full flex justify-center items-center gap-5 `}
                  customStyleDropdownList={`font-montserrat font-medium max-w-[120px] absolute bg-white rounded-md shadow-md w-full mt-3 p-4 flex flex-col justify-center items-center `}
                  liCustomStyle={`cursor-pointer py-2 border-b hover:font-semibold w-full`}
                  options={possessionArrowOptions} onChange={handlePossessionArrow} defaultValue={possessionArrowData} />
              </div>

              {
                shotClockOptions.map((item, index) => (
                  <div key={index}>
                    <p className='text-base text-black font-montserrat font-medium'>{item.sectionLabel}</p>
                    <div className={`${index > 0 ? "ml-5" : ""}`}>
                      {
                        item.sectionValue.map((subItem, subIndex) => (
                          <div key={subIndex} className={`w-full max-w-[672px] flex justify-between items-center ${item.sectionValue.length > 0 ? "mt-4" : ""}`}>
                            <p className='text-base text-black font-montserrat font-medium'>{subItem.label}</p>
                            <Toggle
                              checked={subItem.value}
                              onChange={() => toggleShotClock(subItem.key)}
                            />
                          </div>
                        ))
                      }
                    </div>
                  </div>
                ))
              }

            </div>
        }
      </div>
    </div>

  );
};

export default General;